import { render } from "./AnnouncementsVerify.vue?vue&type=template&id=2ece3d5d&scoped=true"
import script from "./AnnouncementsVerify.vue?vue&type=script&lang=js"
export * from "./AnnouncementsVerify.vue?vue&type=script&lang=js"

import "./AnnouncementsVerify.vue?vue&type=style&index=0&id=2ece3d5d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ece3d5d"]])

export default __exports__